import React from 'react';
import { jc, patchUrlByLocale, addSlashToEndOfUrl } from 'utils';
import {
  variantImageLink,
  variantItemWrap,
  variantLink,
  variantItemWrapInactive,
  variantItemWrapActive,
  disabledFromSelect,
  variantDrawerLink,
  variantImageDrawerLink,
  variantItemDrawerWrapInactive,
  variantItemDrawerWrapActive,
} from './variant-item.styles';

export const DATA_QA_VARIANT_ITEM = 'variant-item';

export interface VariantItemDataProps {
  toProductUrl: string;
}

export interface ProductLinkProps extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  to: (() => string) | string;
}

export type ProductLinkComponentType = React.ComponentType<ProductLinkProps>;

export type VariantItemProps = {
  asImageThumb?: boolean;
  inactive?: boolean;
  active?: boolean;
  disabled?: boolean;
  ProductLinkComponent?: ProductLinkComponentType;
  isDrawerVariant?: boolean;
} & VariantItemDataProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

export const VariantItem = React.forwardRef<HTMLDivElement, VariantItemProps>(
  (
    {
      toProductUrl,
      children,
      className = '',
      ProductLinkComponent,
      asImageThumb,
      inactive,
      active,
      disabled,
      isDrawerVariant = false,
    },
    ref,
  ) => {
    let content = children;
    const slashedToProductURL = addSlashToEndOfUrl(toProductUrl);
    const productUrl = patchUrlByLocale(slashedToProductURL);

    const linkClasses = isDrawerVariant ? [variantDrawerLink] : [variantLink];
    if (asImageThumb) {
      if (isDrawerVariant) {
        linkClasses.push(variantImageDrawerLink);
      } else {
        linkClasses.push(variantImageLink);
      }
    }

    if (ProductLinkComponent) {
      content = (
        <ProductLinkComponent className={jc(...linkClasses)} to={productUrl}>
          {content}
        </ProductLinkComponent>
      );
    } else if (productUrl) {
      content = (
        <a className={jc(...linkClasses, 'a-some-link')} href={productUrl}>
          {content}
        </a>
      );
    }

    const itemClasses = [className, variantItemWrap];
    if (disabled) {
      itemClasses.push(disabledFromSelect);
    }
    if (inactive) {
      if (isDrawerVariant) {
        itemClasses.push(variantItemDrawerWrapInactive);
      } else {
        itemClasses.push(variantItemWrapInactive);
      }
    }
    if (active) {
      if (isDrawerVariant) {
        itemClasses.push(variantItemDrawerWrapActive);
      } else {
        itemClasses.push(variantItemWrapActive);
      }
    }

    return (
      <div data-qa={DATA_QA_VARIANT_ITEM} ref={ref} className={jc(...itemClasses)}>
        {content}
      </div>
    );
  },
);
